import { Injectable } from '@angular/core';
import { format, parse } from 'date-fns';
import { es } from 'date-fns/locale';
import { MessageService } from 'primeng/api';

@Injectable({
  providedIn: 'root'
})
export class UtilsService {

  yesterday: string = '';
  permissions: any = [];

  constructor(
    private messageService: MessageService
  ) {

    const today = new Date();
    const yesterday = new Date(today.getTime());

    const year = yesterday.getFullYear();
    const month = (yesterday.getMonth() + 1).toString().padStart(2, '0');
    const day = yesterday.getDate().toString().padStart(2, '0');

    this.yesterday = `${year}-${month}-${day}`;

  }

  openSnackBar(message: string, severity: string = 'success') {
    this.messageService.add({ severity: severity, summary: 'Info', detail: message });
  }


  onlyNumbers(event: any) {
    const allowedKeys = ['Backspace', 'ArrowLeft', 'ArrowRight', 'Home', 'End'];
    const keyPressed = event.key;

    if (/\D/.test(keyPressed) && !allowedKeys.includes(keyPressed)) {
      event.preventDefault();
    }
  }

  getPaymentMethodsFromTicket(ticket: any) {
    let paymentMethods = '';
    ticket.cashier_entries.forEach((cashierEntry: any) => {
      paymentMethods += cashierEntry.payment_method + ', ';
    });
    paymentMethods = paymentMethods.substring(0, paymentMethods.length - 2);

    return paymentMethods;
  }

  getPaymentMethodsFromInvoice(invoice: any) {
    let paymentMethods: string[] = [];
    if (invoice.reference == '000008-CA25') {
      console.log('invoice: ', invoice);
    }
    if (invoice?.booking?.details) {
      console.log('details: ', invoice.booking.details);
      invoice.booking.details.forEach((detail: any) => {
        if (detail.ticket?.cashier_entries) {
          detail.ticket.cashier_entries.forEach((cashierEntry: any) => {
            paymentMethods.push(cashierEntry.payment_method);
          });
        }
      });
    } else if (invoice?.ticket?.cashier_entries) {
      invoice.ticket.cashier_entries.forEach((cashierEntry: any) => {
        paymentMethods.push(cashierEntry.payment_method);
      });
    }
    paymentMethods = Array.from(new Set(paymentMethods));
    return paymentMethods.map(method => method.toLowerCase()).join(', ');
  }

  onlyNumbersFloat(event: any) {
    const allowedKeys = ['Backspace', 'ArrowLeft', 'ArrowRight', 'Home', 'End'];
    const keyPressed = event.key;

    console.log(keyPressed);

    // Permitir números del 0 al 9, el punto y las teclas permitidas
    if (!/[\d.]/.test(keyPressed) && !allowedKeys.includes(keyPressed)) {
      event.preventDefault();
    }

    // Permitir solo un punto decimal en la entrada
    if (keyPressed === '.' && event.target.value.includes('.')) {
      event.preventDefault();
    }
  }

  onlyNumbersFloatWhitNegative(event: any) {
    const allowedKeys = ['Backspace', 'ArrowLeft', 'ArrowRight', 'Home', 'End'];
    const keyPressed = event.key;

    console.log(keyPressed);

    // Permitir números del 0 al 9, el punto y las teclas permitidas
    if (!/[\d.-]/.test(keyPressed) && !allowedKeys.includes(keyPressed)) {
      event.preventDefault();
    }

    // Permitir solo un punto decimal en la entrada
    if (keyPressed === '.' && event.target.value.includes('.')) {
      event.preventDefault();
    }
  }

  // validate if exist any permission
  validatePermission(permissionName: string) {
    // save permissions
    let user: any = localStorage.getItem('me');
    if (!user) {
      return false;
    }

    user = JSON.parse(user);

    let permissions = [];
    if (user && user != null) {
      permissions = user?.permissions ?? [];
    } else {
      permissions = [];
    }

    return permissions.some((permission: any) => permission.name === permissionName);
  }

  validateRol(rol: string) {

    let user: any = localStorage.getItem('me');
    if (!user) {
      user = null;
    } else {
      user = JSON.parse(user);
    }
    let rols = [];

    if (user) {
      rols = user.roles;
    } else {
      rols = [];
    }

    for (const rolName of rols) {
      if (rol === rolName) {
        return true;
      }
    }
    return false;
  }


  formatDate(dateString: string): string {
    const parsedDate = parse(dateString, 'dd-MM-yyyy', new Date());
    return format(parsedDate, 'EEEE dd  MMMM  yyyy', { locale: es });
  }

  formatHour(hourString: string): string {
    const parsedHour = parse(hourString, 'HH:mm', new Date());
    return format(parsedHour, 'HH:mm')
  }
}
